import { useEffect, useRef } from "react";

export function errorText(value: unknown): string {
  return Array.isArray(value)
    ? value.join(" ")
    : typeof value === "string"
      ? value
      : "";
}
export function FormErrors({
  errors,
  targets = {},
}: {
  errors: Record<string, unknown>;
  targets?: Record<string, string>;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const signature = JSON.stringify(errors);
  useEffect(() => {
    const modal = document.querySelector(
      '[aria-modal="true"], [data-slot="sheet-content"][data-open], [role="alertdialog"]',
    );
    if (
      signature !== "{}" &&
      (!modal || (ref.current && modal.contains(ref.current)))
    )
      ref.current?.focus();
  }, [signature]);
  if (!Object.keys(errors).length) return null;
  return (
    <div
      ref={ref}
      tabIndex={-1}
      role="alert"
      className="rounded-lg border border-destructive p-4 text-sm text-destructive outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      <ul className="space-y-2">
        {Object.entries(errors).map(([field, message]) => (
          <li key={field}>
            {targets[field] ? (
              <a
                className="underline"
                href={`#${targets[field]}`}
                onClick={() => document.getElementById(targets[field])?.focus()}
              >
                {errorText(message)}
              </a>
            ) : (
              errorText(message)
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
